import React, { useEffect, useState } from 'react'
import { MARKET_STATUS_TEXT_COLORS } from '../../utils/MarketStatus';

const StickyHeadingMobile = ({ isMobile, poolsdetail, poolStatus }) => {
    const [showSticky, setShowSticky] = useState(false);
    const statusDotColor = MARKET_STATUS_TEXT_COLORS[poolStatus];
    useEffect(() => {
        const handleScroll = () => {
            const scrollPosition = window.scrollY;
            const triggerHeight = 300;

            if (scrollPosition > triggerHeight) {
                setShowSticky(true);
            } else {
                setShowSticky(false);
            }
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);


    return (
        <>
            {isMobile && showSticky && (
                <div className="sticky-heading-mobile">
                    <div className="main-heading">
                        <span
                            className='dot-color'
                            style={statusDotColor ? { backgroundColor: statusDotColor } : undefined}
                        ></span>
                        <h4>{poolsdetail?.question}</h4>
                    </div>
                </div>
            )}
        </>
    )
}

export default StickyHeadingMobile
